jQuery(document).ready(function ($) {

    $( document ).on( 'click', '.coworker-overlay-open', function(){

        var coworker_image = $(this).data('image');
        $(this).next('.coworker-overlay').append('<img src="'+coworker_image+'" />').fadeIn();

    });

    $('.coworker-overlay').on('click', function (e) {
        if (e.target !== this)
            return;

        $(this).fadeOut();
        $(this).find('img').remove();
    });

    $( document ).on( 'click', '.coworker-overlay-close', function(){

        $(this).parent().fadeOut();
        $(this).parent().find('img').remove();

    });

});